import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57b2f764"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "work-process-mobile" }
const _hoisted_2 = { class: "process-item__title" }
const _hoisted_3 = { class: "process-item__main-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.WORK_PROCESSES, (p, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "work-process-mobile__item process-item"
      }, [
        _createElementVNode("h4", _hoisted_2, _toDisplayString(p.title), 1),
        _createElementVNode("span", _hoisted_3, _toDisplayString(p.mainText), 1)
      ]))
    }), 128))
  ]))
}